<!-- <alert type="danger" *ngIf="error" [dismissible]="true">
  <p class="text-center"><strong>Oh snap!</strong> {{this.errorMessage}}</p>
</alert> -->
<div class="jumbotron jumbotron-fluid center-screen">
  <div style="position: absolute; top: 16px; right: 16px; z-index: 10;">
    <button mat-button (click)="switchLanguage('en')">EN</button>
    <button mat-button (click)="switchLanguage('he')">HE</button>
  </div>
  <div>
    <form [formGroup]="tenantForm" (submit)="login()">
      <h1>
        <img src="./assets/datakamalogo.svg" alt="data*kama" width="200" height="120">
      </h1>

      <mat-card class="card">
        <mat-card-title>{{ 'LOGIN.WELCOME' | translate }}</mat-card-title>
        <mat-card-subtitle>{{ 'LOGIN.ENTER_BUSINESS_NAME_SUBTITLE' | translate }}</mat-card-subtitle>
        <mat-card-content>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'LOGIN.BUSINESS_NAME' | translate }}</mat-label>
            <input
            matInput
            type="tenantname"
            id="tenantname"
            name="tenantname"
            class="form-control"
            formControlName="tenantName"
            placeholder="{{ 'LOGIN.ENTER_BUSINESS_NAME' | translate }}"
            [ngClass]="displayFieldCss('tenantName')"
            required
          />
            <mat-icon matSuffix>home</mat-icon>
          </mat-form-field>
          <mat-card-actions>
            <div class="button-panel">
              <button
                mat-raised-button
                color="primary"
                type="submit"
                [disabled]="!tenantForm.valid"
              >
                {{ 'LOGIN.SUBMIT' | translate }}
              </button>
            </div>
          </mat-card-actions>
        </mat-card-content>
      </mat-card>
    </form>
  </div>
</div>
